module.exports = __webpack_public_path__ + "static/media/dont6.55975446.png";